import { gql } from '@apollo/client'

export const RESET_PASSWORD = gql`
  mutation ResetPassword($inputData: ResetPasswordInput!) {
    resetPassword(inputData: $inputData)
  }
`
